import React, { useState } from "react";
import { TableCell, TableRow, Tooltip, IconButton } from "@material-ui/core"
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { withRouter } from "react-router-dom";
import moment from 'moment';
import config from "../../../config"
import { regexConstants } from "../../../constants/regEx";
import { dayMonthDateFormat,fieldDMYShort } from "../../../constants";
import { getLocalStorageInfo, Comma_format } from "../../../utils"
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { permissionCheckFnforCamo } from "../../../utils";
import { smbcInstance,acumenCamo } from "../../../shared_elements/components";
const FleetAdListing = ({ item, toggleModalFn, toggleDelteModalFn, handleOpenAttachments }) => {
	const [lessMore, setLessMore] = useState({});

	let timezone = moment().format()
	const timestamp = Math.floor(Date.now() / 1000);

	const fleet_AdUrl = `audit/camo/fleetadstatus/?object_id=${item.id}&action=0,1&timezone=${timezone}&timestamp=${timestamp}`
	const toggleLessMore = (lessMr) => {
		setLessMore({
			...lessMore,
			[lessMr]: !lessMore[lessMr]
		});
	}
	const lessMoreFn = (name, lessMr) => {
		return <>
			{name && name?.length > 35 ? (
				<>
					{lessMore[lessMr] ?
						(<> {name} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..less </span> </>)
						:
						(<>{name?.substring(0, 35)} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..more </span> </>)
					}
				</>
			) : name || '--'
			}
		</>
	}
	return (
		<>
			{/* <TableRow >
				<TableCell >
					{permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) ? <Tooltip title="Edit" arrow placement='top'>
						<IconButton style={{ padding: 'unset' }} color='primary' onClick={toggleModalFn} >
							<CreateOutlinedIcon />
						</IconButton>
					</Tooltip> : null}
					{permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) ? <Tooltip title="Delete"  arrow placement='top' >
						<IconButton style={{ padding: 'unset' }} color='secondary' onClick={toggleDelteModalFn}>
							<DeleteOutlinedIcon />
						</IconButton>
					</Tooltip> : null}
					<RevisionHistory buttonType={true} url={fleet_AdUrl} />
				</TableCell>
				<TableCell>{smbcInstance ? item.faa_ad : item?.ata || "--"}</TableCell>
				<TableCell>{smbcInstance ? item.faa_superseded : item.ad_no || "--"} </TableCell>
				{smbcInstance ? <TableCell>{item.easa_ad || '--'}</TableCell> : null}
				<TableCell>{smbcInstance ? item.easa_superseded : item.issuing_authority || "--"} </TableCell>
				<TableCell style={{ width: "200px", textAlign: "left" }}>{lessMoreFn(item?.description, "description")}</TableCell>
				{smbcInstance ? <TableCell>{lessMoreFn(item?.related_document, "related_document")}</TableCell> : null}
				<TableCell> {lessMoreFn(item?.applicability?.map((item) => item?.name).filter(Boolean).join(', '), "applicability")} </TableCell>
				<TableCell>{lessMoreFn(item?.effectivity, "effectivity")}</TableCell>
				{smbcInstance ? <TableCell>{item?.faa_effective_date ? moment(item.faa_effective_date).format(dayMonthDateFormat) : "--"}</TableCell> : null}
				{smbcInstance ? <TableCell>{item?.easa_effective_date ? moment(item.easa_effective_date).format(dayMonthDateFormat) : "--"}</TableCell> : null}
				{smbcInstance ? null : <TableCell>{item.ad_type ? item.ad_type : "--"}</TableCell>}
				{smbcInstance ? null : <TableCell>{item.effective_date ? moment(item.effective_date).format(dayMonthDateFormat) : "--"}  </TableCell>}
				{smbcInstance ? null : <TableCell>{item.dimension_type ? item.dimension_type : "--"}  </TableCell>}
				<TableCell>{item.ad_compliance_status ? item.ad_compliance_status : "--"} </TableCell>
				{smbcInstance ? null : <TableCell>{item.ad_compliance_tsn ? regexConstants.alphanumespcespclchar.test(item.ad_compliance_tsn) ? item.ad_compliance_tsn : Comma_format(parseInt(item.ad_compliance_tsn)) : "--"} </TableCell>}
				{smbcInstance ? null : <TableCell>{item.ad_compliance_csn ? regexConstants.alphanumespcespclchar.test(item.ad_compliance_csn) ? item.ad_compliance_csn : Comma_format(parseInt(item.ad_compliance_csn)) : "--"} </TableCell>}
				{smbcInstance ? null : <TableCell>{item.ad_compliance_date ? moment(item.ad_compliance_date).format(dayMonthDateFormat) : "--"}</TableCell>}
				{smbcInstance ? null : <TableCell>{item.sb_number ? item.sb_number : "--"}</TableCell>}
				{smbcInstance ? <TableCell>{item?.reference || "--"}</TableCell> : null}
				{smbcInstance ? <TableCell>{lessMoreFn(item?.remark, "remark")}</TableCell> : null}
				<TableCell>
					{item.attachments?.length > 0 ? (
						<>
							<Tooltip title="View Attachments">
								<span className="center" >
									<AttachFileIcon className="attach-icon" onClick={handleOpenAttachments} />
									<a href="#" style={{ color: "#0e7fe1" }}>{item.attachments?.length > 0 && item.attachments?.length}</a>
								</span>
							</Tooltip>
						</>
					)
						: (
							"--"
						)}
				</TableCell>
			</TableRow> */}
      {/* SMBC Replicate */}
			<TableRow >
				<TableCell>
					<div style={{ alignItems: "center", gap: "2px" }}>
						{permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) ? <Tooltip title="Edit" placement='top'>
							<IconButton style={{ padding: 'unset' }} color='primary' onClick={toggleModalFn} >
								<CreateOutlinedIcon />
							</IconButton>
						</Tooltip> : null}
						{permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) ? <Tooltip title="Delete" placement='top' >
							<IconButton style={{ padding: 'unset' }} color='secondary' onClick={toggleDelteModalFn}>
								<DeleteOutlinedIcon />
							</IconButton>
						</Tooltip> : null}
						<RevisionHistory buttonType={true} url={fleet_AdUrl} />
						{item?.attachments?.length > 0 ? (
							<>
								<Tooltip title="View Attachments">
									<span style={{ verticalAlign: 'middle', cursor: 'pointer' }}>
										<AttachFileIcon className="attach-icon" onClick={handleOpenAttachments} color='primary' />
										<a href="#" style={{ color: "#0e7fe1" }}>{item.attachments?.length > 0 && item.attachments?.length}</a>
									</span>
								</Tooltip>
							</>
						)
							:
							null
						}
					</div>
				</TableCell>
				<TableCell style={{ minWidth: "130px"}}>{item.faa_ad || "--"}</TableCell>
				<TableCell style={{ minWidth: "130px"}}>{item.faa_superseded || "--"} </TableCell>
				<TableCell style={{ minWidth: "120px"}}>{item.easa_ad || '--'}</TableCell>
				<TableCell style={{ minWidth: "130px"}}>{item.easa_superseded || "--"} </TableCell>
				<TableCell style={{ minWidth: "200px"}}>{lessMoreFn(item?.description, "description")}</TableCell>
				<TableCell style={{ minWidth: "180px"}}>{lessMoreFn(item?.related_document, "related_document")}</TableCell>
				<TableCell style={{ minWidth: "250px"}}>{lessMoreFn(item?.applicability?.map((item) => item?.name).filter(Boolean).join(', '), "applicability")} </TableCell>
				<TableCell style={{ minWidth: "180px"}}>{lessMoreFn(item?.effectivity, "effectivity")}</TableCell>
				<TableCell style={{ minWidth: "100px"}}>{item?.faa_effective_date ? moment(item.faa_effective_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</TableCell>
				<TableCell style={{ minWidth: "100px"}}>{item?.easa_effective_date ? moment(item.easa_effective_date).format(acumenCamo ? fieldDMYShort :dayMonthDateFormat ) : "--"}</TableCell>
				<TableCell style={{ minWidth: "100px"}}>{item.ad_compliance_status ? item.ad_compliance_status : "--"} </TableCell>
				<TableCell style={{ minWidth: "100px"}}>{item?.reference || "--"}</TableCell>
				<TableCell style={{ minWidth: "180px"}}>{lessMoreFn(item?.remark, "remark")}</TableCell>
				<TableCell style={{ minWidth: "130px",cursor:(item?.ad_assessment_status === "N/A" || item?.ad_assessment_status === null) ? "": 'pointer',color:"blue"}} onClick={(e)=> (item?.ad_assessment_status === "N/A" || item?.ad_assessment_status === null) ? e.preventDefault() : toggleModalFn() }>{item?.ad_assessment_status || "--"}</TableCell>
				{/* <TableCell>
					{item.attachments?.length > 0 ? (
						<>
							<Tooltip title="View Attachments">
								<span className="center" >
									<AttachFileIcon className="attach-icon" onClick={handleOpenAttachments} />
									<a href="#" style={{ color: "#0e7fe1" }}>{item.attachments?.length > 0 && item.attachments?.length}</a>
								</span>
							</Tooltip>
						</>
					)
						: (
							"--"
						)}
				</TableCell> */}
			</TableRow>
		</>
	)
}

export default withRouter(FleetAdListing)